
export const students = [{
  bannerImg: "https://d36rc1r950nl44.cloudfront.net/test/18d4a409-0f1b-479b-bad9-c100958b83c1/events/banner-upload/14i86y70rnm46lwerr.webp",
  undelineWidth:'119px',
  course: 'The Marketing Launchpad',
  courseSub:'',
  name: 'Sumit Kakkad',
  previous: `Mechanical Engineer`,
  now: `Retention Marketing<br/> Executive @ Toothsi`,
  youtubeLink: 'https://youtube.com/watch?v=_djT0XMZV38',
  listen: 'Listen to his story'
},{
  bannerImg: "https://d36rc1r950nl44.cloudfront.net/test/18d4a409-0f1b-479b-bad9-c100958b83c1/events/banner-upload/14i86y70rnm46lqtbe.webp",
  undelineWidth:'119px',
  course: 'The Marketing Launchpad',
  courseSub:'(Emerging Talent)',
  name: 'Sonia Prasad',
  previous: `B.Com Undergraduate,<br/> UPSC aspirant`,
  now: `Digital Marketing <br/>Executive @ Qtonz <br/>Infosoft`,
  youtubeLink: 'https://youtu.be/MENQFN7qZDo',
  listen: 'Listen to her story'
},{
  bannerImg: "https://d36rc1r950nl44.cloudfront.net/test/18d4a409-0f1b-479b-bad9-c100958b83c1/events/banner-upload/14i86y70rnm46lp07a.webp",
  undelineWidth: '57px',
  course: `PGP in AI-Led Sales,  Marketing and Business`,
  courseSub:'',
  name: 'Kratika',
  previous: `Science graduate +<br/> BPO experience`   ,
  now: `Sales Executive Trainee <br/>@ Nestle`,
  youtubeLink: 'https://youtu.be/KtxXdlcZNw4',
  listen: 'Listen to her story'
},{
  bannerImg:"https://d36rc1r950nl44.cloudfront.net/test/18d4a409-0f1b-479b-bad9-c100958b83c1/events/banner-upload/14i86y8422m4gn81am.webp",
  undelineWidth: '119px',
  course: `Content and Social <br class="mobile-none" />Media Launchpad`,
  courseSub:'',
  name: 'Srishti Agnihotri',
  previous: `System Engineer <br/>@ Infosys`,
  now: `Content Marketer @<br/> Skyline Construction`,
  youtubeLink: 'https://www.youtube.com/watch?v=y-NJvUgsQ38&ab_channel=Kraftshala',
  listen: 'Listen to her story'
}];